import TextFieldMui from 'src/components/TextFieldMui'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Controller, UseFormRegister, Control } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as S from './TaxCouponFormWeight.styles'
import Suffix from '../Suffix/Suffix'
import { ItemData } from 'src/features/tax-coupon/TaxCouponTypes'

dayjs.extend(utc)

interface ItemFormProps {
    entryDataIsComplete: boolean,
    control: Control<ItemData, any>,
    errors: any,
    register: UseFormRegister<ItemData>
    currencyFormatter: (formatted_value: any) => string
    formatWeight: (formatted_value: any) => string
}

export default ({
  entryDataIsComplete, control, errors, register, currencyFormatter, formatWeight,
}: ItemFormProps) => (
  <S.ItemContainer>
    <Suffix suffix='KG'>
      <Controller
        control={control}
        name='quantity'
        rules={{ required: 'Campo obrigatório' }}
        render={({ field: { onChange, name, value } }) => (
          <NumberFormat
            customInput={TextFieldMui}
            style={S.NumberFormatStyles}
            label='taxCoupon.weight'
            id='quantity'
            name={name}
            value={value}
            onChange={onChange}
            format={formatWeight}
            decimalScale={3}
            decimalSeparator=','
            inputProps={{ 'data-testid': 'quantity-test' }}
            placeholder='0,000'
            error={!!errors.quantity}
            helperText={errors.quantity?.message}
          />
        )}
      />
    </Suffix>
    <Controller
      control={control}
      name='unitCost'
      rules={{ required: 'Campo obrigatório' }}
      render={({ field: { onChange, name, value } }) => (
        <NumberFormat
          customInput={TextFieldMui}
          style={S.NumberFormatStyles}
          thousandSeparator='.'
          decimalSeparator=','
          allowEmptyFormatting
          format={currencyFormatter}
          decimalScale={2}
          prefix='R$ '
          label='taxCoupon.unitCost.weight'
          name={name}
          value={value}
          onChange={onChange}
          error={!!errors.unitCost}
          helperText={errors.unitCost?.message}
          disabled={!entryDataIsComplete}
          inputProps={{ 'data-testid': 'unitCost-test' }}
        />
      )}
    />
    <S.Input
      label='taxCoupon.expirationDate'
      name='expirationDate'
      id='expirationDate'
      type='date'
      inputProps={{
        ...register('expirationDate', {
          required: 'Campo obrigatório',
          validate: { atLeastToday: (v) => dayjs(v) >= dayjs() || 'Data anterior ou atual inválida' },
        }),
        'data-testid': 'expirationDate-test',
        min: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      }}
      error={!!errors.expirationDate}
      helperText={errors.expirationDate?.message}
      InputLabelProps={{ shrink: true }}
      disabled={!entryDataIsComplete}
    />
    <S.ButtonSubmit
      disabled={!entryDataIsComplete}
      title='Adicionar'
      type='submit'
      bgColor='blue'
      hoverColor='darkBlueHover'
      letterColor='white'
    />
  </S.ItemContainer>
)
